import PilotDocumentsAPI from 'dashboard/api/pilot/documents';
import { createStore } from '../storeFactory';

export default createStore({
  name: 'PilotDocument',
  API: PilotDocumentsAPI,
});
